import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VueI18n from "vue-i18n";
import i18n from "./i18n/index.js";
import Vant from "vant";
import "vant/lib/index.css";
import "./style/index.css"
Vue.config.productionTip = false;
Vue.use(Vant);

new Vue({
  VueI18n,
  i18n,
  router,
  render: (h) => h(App),
}).$mount("#app");
